import * as type from './types';

export function projectsAvailableData(data) {
    return {
        type: type.GET_PROJECTS_AVAILABLE_DATA_REQUESTED,
        data: data,
    }
}